import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { boxShadow815Grey } from 'approot/shared/styles/borders.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { spacing4, spacing12 } from 'approot/shared/styles/spacing.style';
import { PrimaryButtonColours } from 'approot/shared/styles/buttons/primary-button.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  ButtonBaseProps,
  ButtonBaseStyled,
} from 'approot/shared/styles/buttons/base-button.style';

type TTSContainerProps = {
  $isInPlayMode: boolean;
};
export const TTSContainer = styled.div<TTSContainerProps>`
  ${flexCentreAlignCss}
  ${({ $isInPlayMode }) => $isInPlayMode && boxShadow815Grey}

  display: inline-flex;
  background-color: ${grey1};
  border-radius: ${rem(48)};
  border: 1px solid ${grey5};
  gap: ${rem(spacing12)};
  padding: ${rem(spacing4)};
`;

type TTSPlayPauseProps = ButtonBaseProps & {
  $isPlay: boolean;
};
export const TTSPlayPause = styled.button<TTSPlayPauseProps>`
  ${ButtonBaseStyled}

  ${({ $isPlay }) =>
    $isPlay
      ? css`
          ${SecondaryBaseStyled}
        `
      : css`
          ${PrimaryButtonColours}
          svg path {
            stroke: ${grey1};
          }
        `}

  // order here matters, these styles have to be down here
  border-radius: ${rem(40)};
  gap: ${rem(spacing12)};
  ${flexCentreAlignCss}
`;
